export default __webpack_public_path__ + "pgnv-assets/e9593ef651e9ed3db862a4ded7b14ca5.png";